class CartOffers {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-offers-open]');
      if (openButton) {
        const wrapper = openButton.closest('[data-cart-offers]');
        if (!wrapper) return;
        const dialog = wrapper.querySelector('[data-offers-dialog]');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', 'open');
        }
        return;
      }

      const closeButton = event.target.closest('[data-offers-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-offers-dialog]');
        if (!dialog) return;
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        return;
      }

      const offerItem = event.target.closest('[data-offer-code]');
      if (offerItem) {
        const code = offerItem.dataset.offerCode;
        if (!code) return;
        const dialog = offerItem.closest('[data-offers-dialog]');
        const form = offerItem.closest('[data-cart-offers]')?.querySelector('[data-coupon-form]');
        if (!form) return;
        const input = form.querySelector('input[name="discount_code"]');
        if (!input) return;
        input.value = code;
        if (dialog && typeof dialog.close === 'function') {
          dialog.close();
        } else if (dialog) {
          dialog.removeAttribute('open');
        }
        return;
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-coupon-form]');
      if (!form) return;

      event.preventDefault();

      const wrapper = form.closest('[data-cart-offers]');
      const messageEl = wrapper ? wrapper.querySelector('[data-coupon-message]') : null;
      const input = form.querySelector('input[name="discount_code"]');

      if (!input) return;

      const code = input.value.trim().toUpperCase();
      const allowedCsv = (form.dataset.offerCodes || '').trim();
      const allowedCodes = allowedCsv
        .split(',')
        .map((item) => item.trim().toUpperCase())
        .filter(Boolean);

      if (!code) {
        this.showMessage(messageEl, 'Enter a coupon code.', true);
        return;
      }

      if (!allowedCodes.length) {
        this.showMessage(
          messageEl,
          'No offers configured. Add offer blocks in cart section and copy the same codes from Shopify Discounts.',
          true
        );
        return;
      }

      if (!allowedCodes.includes(code)) {
        this.showMessage(messageEl, 'Please use a coupon from View offers.', true);
        return;
      }

      this.showMessage(messageEl, 'Applying coupon...', false);
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
    });
  }

  showMessage(messageEl, message, isError) {
    if (!messageEl) return;
    messageEl.hidden = false;
    messageEl.textContent = message;
    messageEl.classList.toggle('is-error', isError);
  }
}

function initStickyCheckout() {
  const stickyBar = document.getElementById('cart-sticky-checkout');
  const mainCheckout = document.querySelector('.cart-modern__checkout--summary');
  if (!stickyBar || !mainCheckout) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.hidden = true;
      } else {
        stickyBar.hidden = false;
      }
    },
    { threshold: 0, rootMargin: '0px 0px -20px 0px' }
  );
  observer.observe(mainCheckout);
}

if (!window.__cartOffersInitialized) {
  window.__cartOffersInitialized = true;
  new CartOffers();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCheckout);
  } else {
    initStickyCheckout();
  }
}
